import { Directive, inject, input, InputSignal } from '@angular/core';
import { SearchChannel } from '../service/search.channels';
import { SearchService } from '../service/search.service';
import { AbstractSearchDirective } from './abstract-search.directive';

@Directive({
  selector: '[ngModel][appSearch]',
  exportAs: 'appSearch',
})
export class AppSearchDirective extends AbstractSearchDirective<SearchChannel> {
  #searchService = inject(SearchService);

  readonly appSearch = input<SearchChannel>();

  readonly channelInput: InputSignal<SearchChannel> = this
    .appSearch as InputSignal<SearchChannel>;

  protected setSearch(channel: SearchChannel, value: string) {
    this.#searchService.setSearch(channel, value);
  }
}
